import React from 'react'
import Header from "../componets/Header";
import Footer from "../componets/Footer";
import Faq from '../componets/faq/Faq'

const FAQ = () => {
    return (
        <>
            <Header />
            <Faq />
            <Footer />
        </>
    )
}

export default FAQ